var pug = require("!../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Crouter-outlet\u003E\u003C\u002Frouter-outlet\u003E\u003Coz-secret-trigger\u003E\u003C\u002Foz-secret-trigger\u003E";;return pug_html;};
module.exports = template;